import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, Image, TextInput } from '../../types'
import { CallToActionButtonData } from '../../shared/call-to-action-button/call-to-action-button.component.converter'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'
import { ImageViewport } from '../../../enums/image-viewports'

@Injectable({ providedIn: 'root' })
export class SlashHeaderConverter extends CmsConverterService<SlashHeaderData> {

  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const xl = formData.st_slash_header_size?.value?.identifier === 'large'
      ? CmsConverterService.getImageSize(formData.st_slash_header_image_reference, ImageViewport.W2H1, 1920)
      : CmsConverterService.getImageSize(formData.st_slash_header_image_reference, ImageViewport.W3H1, 1920)
    const lg = formData.st_slash_header_size?.value?.identifier === 'large'
      ? CmsConverterService.getImageSize(formData.st_slash_header_image_reference, ImageViewport.W2H1, 1200)
      : CmsConverterService.getImageSize(formData.st_slash_header_image_reference, ImageViewport.W3H1, 1200)
    const md = formData.st_slash_header_size?.value?.identifier === 'large'
      ? CmsConverterService.getImageSize(formData.st_slash_header_image_reference, ImageViewport.W2H1, 990)
      : CmsConverterService.getImageSize(formData.st_slash_header_image_reference, ImageViewport.W3H1, 990)
    const sm = formData.st_slash_header_size?.value?.identifier === 'large'
      ? CmsConverterService.getImageSize(formData.st_slash_header_image_reference, ImageViewport.W1H1, 768)
      : CmsConverterService.getImageSize(formData.st_slash_header_image_reference, ImageViewport.W1H1, 768)
    const xs = formData.st_slash_header_size?.value?.identifier === 'large'
      ? CmsConverterService.getImageSize(formData.st_slash_header_image_reference, ImageViewport.W1H1, 480)
      : CmsConverterService.getImageSize(formData.st_slash_header_image_reference, ImageViewport.W1H1, 480)
    return {
      headline: formData.st_slash_header_headline ?? defaultTextInput,
      description: formData.st_slash_header_description ?? defaultTextInput,
      gradient: {
        name: formData.st_slash_header_gradient_type?.name ?? '',
        value: formData.st_slash_header_gradient_type?.value?.identifier ?? '',
      },
      imagePosition: formData.st_slash_header_image_position?.value?.identifier ?? '',
      size: formData.st_slash_header_size?.value?.identifier ?? '',
      image: {
        mime: formData.st_slash_header_image_reference?.value?.[0]?.value?.target?.mime,
        xl,
        lg,
        md,
        sm,
        xs,
        altText: formData.slash_header_alternative_text?.value ||
          formData.st_slash_header_image_reference?.value?.[0]?.value?.target?.altTag || '',
        lazyLoad: formData.st_image_lazy_loading?.value ?? true,
      },
      buttons: formData.st_slash_header_call_to_actions ?? defaultFSCatalog
    }
  }
}

export const SLASH_HEADER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, SlashHeaderData>>('SlashHeaderConverter')

export interface SlashHeaderData extends ConvertedComponentData {
  headline: TextInput;
  description: TextInput;
  gradient: TextInput;
  imagePosition: string;
  size: string;
  image: Image;
  buttons: FsCatalog<CallToActionButtonData>;
}
